import { Box, styled } from '@mui/material';

export const StyledNotFoundDataContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  height: '50vh',
  gap: '10px',
  borderRadius: '45px',
  border: `1px solid ${theme.palette.custom.grey6}`,
  backgroundColor: theme.palette.custom.grey8,
}));
